const STORAGE_KEY = 'pga-guest-private-booking'

export const saveGuestBooking = booking => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(booking))
}

export const loadGuestBooking = () => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

export const clearGuestBooking = () => {
  sessionStorage.removeItem(STORAGE_KEY)
}

export const withGuestBookingParam = currentUrl => {
  const [path, search = ''] = currentUrl.split('?')
  const params = new URLSearchParams(search)
  params.set('guestBooking', '1')
  const nextSearch = params.toString()
  return nextSearch ? `${path}?${nextSearch}` : path
}

export const digitsOnly = value => (value || '').replace(/\D/g, '')
